import { connect } from 'react-refetch';
import 'isomorphic-fetch';

export default Component =>
  connect(props => ({
    isGdprFetch: props.gdprApiUrl || 'https://gdpr-service.herokuapp.com/is-gdpr',
    postContactForm: data => ({
      postContactFormResponse: {
        url: 'https://wt-139739a316b9b05b2ef2d61c5ed80be7-0.sandbox.auth0-extend.com/contact-form',
        method: 'POST',
        body: JSON.stringify(data)
      }
    }),
    postExtraData: data => ({
      postExtraDataResponse: {
        url: props.extraDataForPosting.url,
        method: 'POST',
        body: JSON.stringify({
          data: {
            content: data
          }
        })
      }
    })
  }))(Component);



// WEBPACK FOOTER //
// ./src/components/ContactUsForm/connect.js